import { render } from "./MapPage.vue?vue&type=template&id=4a0fd20d"
import script from "./MapPage.vue?vue&type=script&lang=js"
export * from "./MapPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__